import { Navigate } from "react-router-dom";
import { Card } from "@volca/ui/components/ui/card";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";
import { useBusiness } from "@/core/business";

const BusinessSettingsRedirect = () => {
  const { businessId, isLoading } = useBusiness();

  if (isLoading) {
    return (
      <Stack align="start" gap={4} className="h-full w-full px-6 py-8">
        <Card className="h-full w-full flex-row items-center justify-center gap-0 overflow-auto p-6">
          <Spinner
            layout="centered"
            flexHeight
            aria-label="Loading business settings"
          />
        </Card>
      </Stack>
    );
  }

  if (!businessId) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Navigate to={`/business-settings/${businessId}`} replace />;
};

export default BusinessSettingsRedirect;
